/*
 * Flags dormentes do frontend (FE-0 CP-D — ADR 0026 §Flags dormentes).
 *
 * DEFAULT-OFF no CÓDIGO: a ausência da env, ou qualquer valor que não seja
 * exatamente "true"/"1", resulta em `false`. Ligar uma flag é responsabilidade
 * EXCLUSIVA do `.env` (ON apenas em dev — ver `frontend/.env.development`).
 *
 * Estas NÃO são segredos: são booleanos de habilitação de módulo. Espelham as
 * flags dormentes do backend (`projecao_ativa`, `conciliacao_ativa`) e o gate
 * de disponibilidade da API autenticada do painel.
 */

/** Nomes canônicos das flags — fonte única para evitar typo em strings soltas. */
export const NOMES_FLAGS = [
  "projecao_ativa",
  "conciliacao_ativa",
  "api_autenticada_disponivel",
] as const;

export type NomeFlag = (typeof NOMES_FLAGS)[number];

/**
 * Interpreta um valor cru de env como booleano DEFAULT-OFF.
 * Só "true" ou "1" (string exata) ligam; tudo mais (incluindo `undefined`,
 * "false", "0", "yes", "" e qualquer ruído) fica `false`.
 */
function interpretar(valor: string | boolean | undefined): boolean {
  if (valor === true) return true;
  return valor === "true" || valor === "1";
}

/**
 * Lê o ambiente do Vite. As envs do Vite são prefixadas com `VITE_`; as flags
 * vivem como `VITE_PROJECAO_ATIVA`, etc. Mapeia o nome canônico para a chave
 * de env correspondente.
 */
function chaveEnv(nome: NomeFlag): string {
  return `VITE_${nome.toUpperCase()}`;
}

/**
 * Lê todas as flags do ambiente injetado pelo Vite (`import.meta.env`).
 * Cada flag é resolvida de forma independente e DEFAULT-OFF.
 */
export function lerFlags(
  ambiente: Record<string, string | boolean | undefined> = import.meta.env,
): Record<NomeFlag, boolean> {
  const resultado = {} as Record<NomeFlag, boolean>;
  for (const nome of NOMES_FLAGS) {
    resultado[nome] = interpretar(ambiente[chaveEnv(nome)]);
  }
  return resultado;
}

/** Conveniência: uma flag específica está ligada? (DEFAULT-OFF). */
export function flagAtiva(
  nome: NomeFlag,
  ambiente: Record<string, string | boolean | undefined> = import.meta.env,
): boolean {
  return interpretar(ambiente[chaveEnv(nome)]);
}
